import React from "react";
import { Button, Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';

export default class DetailScreen extends React.Component {
    state = {
        pathParams: {},
        origItemData: null,
        itemData: null
    }
    _ismounted = false;
    uuidFieldName = "uuid";

    componentDidMount() {
        this._ismounted = true;
        const match = context.matchPath(this.pathPrefix);
        if (match) {
            this.setState({ pathParams: match.params }, () => {
                this.updateData(match.params.recordId);
            });
        }
    }
    
    componentWillUnmount() {
        this._ismounted = false;
    }

    async updateData(uuid, cb) {
        let params = {};
        params[this.uuidFieldName] = uuid || this.state.pathParams.recordId;
        let itemData = await context.makeRequest(this.methodName, params);
        //console.log("itemData", itemData);

        if (!this._ismounted)
            return;

        if (Array.isArray(itemData.result) && itemData.result?.length > 0) {
            this.setState({ 
                origItemData: itemData.result[0], 
                itemData: JSON.parse(JSON.stringify(itemData.result[0])) 
            }, cb);
        } else if (itemData.result && itemData.result.items?.length > 0) {
            this.setState({ 
                origItemData: itemData.result.items[0], 
                itemData: JSON.parse(JSON.stringify(itemData.result.items[0])) 
            }, cb);
        } else {
            this.setState({
                itemData: false
            }, cb);
        }
    }

    checkload() {
        if (this.state.itemData === false) {
            const match = context.matchPath(this.pathPrefix);
            return ( "Item with UUID " + match.params.recordId + " not found" );
        } else if (!this.state.itemData) {
            return ( "Loading..." );
        }
        return true;
    }

    async disassociateRecord(confirmed = false) {
        let reqParams = { ...this.state.itemData };

        if (!confirmed) {
            this.setState({ 
                disassociateConfirm: true
            });
            return;
        }
        
        let itemData = await context.makeRequest(this.methodPrefix + ".disassociate", reqParams);
        this.updateData();
        if (itemData.result === true) {
            alert("success");
        } else {
            alert("Error: " + itemData.error?.message);
        }
    }

    async deleteRecord(confirmed = false) {
        let reqParams = { ...this.state.itemData };

        if (!confirmed) {
            this.setState({ 
                deleteConfirm: true
            });
            return;
        }
        
        let itemData = await context.makeRequest(this.methodPrefix + ".delete", reqParams);
        if (itemData.result === true) {
            alert("success");
            context.navigate(this.pathPrefix);
        } else {
            alert("Error: " + itemData.error?.message);
        }
    }

    getModal(modalContents) {
        modalContents = modalContents ? modalContents : this.getModalContents();
        return (
            <Modal
                show={ modalContents ? true : false } 
                backdrop="static"
                onHide={ modalContents?.onCancel }
            >
                <Modal.Header closeButton >
                    <Modal.Title>{modalContents?.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalContents?.body}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={ modalContents?.onCancel }>Cancel</Button>
                    <Button variant="primary" onClick={ modalContents?.onConfirm }>{ modalContents?.confirmButtonText || "Confirm" }</Button>
                </Modal.Footer>
            </Modal>
        );
    }
    getModalContents() {
        let modalContents;
        if (this.state.deleteConfirm) {
            modalContents = {
                title: "Delete Record",
                body: (<p>Are you sure you want to delete? <br/> This will delete all related records as well!</p>),
                confirmButtonText: "Delete",
                onCancel: () => {
                    this.setState({ deleteConfirm: false });
                },
                onConfirm: () => { this.setState({ deleteConfirm: false }) ; this.deleteRecord(true) }
            };
        }
        if (this.state.disassociateConfirm) {
            modalContents = {
                title: "Disassociate device from site",
                body: (
                    <div>
                        <h1>DANGER ZONE</h1>
                        <h2>Are you sure you want to Disassociate?</h2>
                        <div>You should only do this if</div>
                        <ul>
                            <li>Device was returned to us</li>
                            <li>Device is confirmed to be destroyed</li>
                            <li>Your name is Christian and you are performing tests</li>
                        </ul>
                        <div style={{ fontWeight: 'bold' }}>Do NOT do this if you are trying to transfer</div>
                    </div>
                ),
                confirmButtonText: "Disassociate",
                onCancel: () => {
                    this.setState({ disassociateConfirm: false });
                },
                onConfirm: () => { this.setState({ disassociateConfirm: false }) ; this.disassociateRecord(true) }
            };
        }
        return modalContents;
    }

    clearExtraElement() {
        this.extraElement = null;
        this.setState({});
    }

    render() { 
        if (this.checkload() !== true) {
            return this.checkload();
        }
        
        return ( 
            <div>
                <div>
                    Uuid: { this.state.itemData.uuid }
                </div>
            </div>
        );
    }
}